import { render, staticRenderFns } from "./TournamentControls.vue?vue&type=template&id=1862a745&"
import script from "./TournamentControls.vue?vue&type=script&lang=js&"
export * from "./TournamentControls.vue?vue&type=script&lang=js&"
import style0 from "./TournamentControls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VFlex,VLayout,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1862a745')) {
      api.createRecord('1862a745', component.options)
    } else {
      api.reload('1862a745', component.options)
    }
    module.hot.accept("./TournamentControls.vue?vue&type=template&id=1862a745&", function () {
      api.rerender('1862a745', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tournament/TournamentControls.vue"
export default component.exports